(ns teamoesterreich.admin-mode.lebensretter.incident.incident-info-modal
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [teamoesterreich.util.log :as log]
            ))


(defn info-modal [!show !rows]
  (when (and @!show (not-empty @!rows))
    (let [details (first (filter (fn [e] (= (get e "incident-uuid") @!show)) @!rows))
          date (get details "incident-date")]
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (if @!show true false)

        }
       [:div
        {
         :class "modal"
         :style {:width 600}}
        [:h4 (str "Details zum Einsatz: " @!show)]

        [:table
         [:tr [:td "Zeit:"] [:td {:colspan 5 :style {:color "blue"}}
                             [:span (str (subs date 6 8) "." (subs date 4 6) "." (subs date 0 4))
                              "  "
                              (str (subs date 9 11) ":" (subs date 11 13) ":" (subs date 13 15))
                              ]]]
         [:tr [:td "Nummer:"] [:td {:colspan 5 :style {:color "blue"}}
                               (get details "incident-external-id")]]
         [:tr [:td "Status:"] [:td {:colspan 5 :style {:color "blue"}}
                               (get details "incident-status")]]
         [:tr [:td "Plz:"] [:td {:colspan 5 :style {:color "blue"}}
                            (get details "incident-alert-zip")]]
         [:tr [:td "Lebensretter:"] [:td {:colspan 5 :style {:color "blue"}}
                                     ""]]
         (for [intervention (get details "intervention")]
           ^{:key (str "int-" (get intervention "intervention-uuid"))}
           [:tr
            [:td]
            [:td (str (get intervention "toe-toeId"))]
            [:td (get intervention "toe-email")]
            ])

         ]


        [:br]
        [:br]

        [mui/button
         {:style     {:float "right"}
          :variant   "contained"
          :startIcon (r/as-element [done])
          :onClick   (fn []
                       (reset! !show nil))
          }
         "Ok"]]
       ]
      )))


